'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.submitErrors') || empty;
    };
  };
};

exports.default = createGetFormSubmitErrors;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/selectors/getFormSubmitErrors.js
// module id = 1281
// module chunks = 0